import { PlayerConfig } from './PlayerConfig';
import { Element } from './Element/Element';

type CompositionOverrideProps = {
  durationInFrames?: number;
  fps?: number;
  height?: number;
  width?: number;
};

export type ElementPositions = Pick<React.CSSProperties, 'left' | 'top' | 'width' | 'height' | 'zIndex'>;

export type CompositionConfig = CompositionOverrideProps & {
  playerConfig: PlayerConfig;
  version: string;
  showPlayerFrames?: boolean;
  onOutlineRelease?: (positions: ElementPositions, element?: Element) => void;
  onOutlineResize?: (positions: ElementPositions, selectionElementType: SelectionElementType) => void;
  canEditCaptions?: boolean;
  disableCaptionsDragging?: boolean;
  disableCaptionsResize?: boolean;
  canEditSpeakerLabel?: boolean;
  canEditImages?: boolean;
  canManuallyReposition?: boolean;
  canEditTextElements?: boolean;
  canEditVideos?: boolean;
  canEditLottie?: boolean;
  preventOverlappingWithOtherCrops?: boolean;
};
export enum SelectionElementType {
  CAPTIONS = 'CAPTIONS',
  SPEAKER_LABEL = 'SPEAKER_LABEL',
  SPEAKER_LABEL_TITLE = 'SPEAKER_LABEL_TITLE',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  LOTTIE = 'LOTTIE',
  VIDEO_IN_COMPOSITE = 'VIDEO_IN_COMPOSITE'
}
